// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_container__3M4qI","gonganju":"footer_gonganju__2dMUH","gonganjuImg":"footer_gonganjuImg__1ChM8"};